import React, { useEffect, useState } from 'react';
import { Modal, Input } from 'antd';
import './ImageSelectorModal.css';
import ImagePicker from 'react-image-picker';
import 'react-image-picker/dist/index.css';
import { SearchOutlined } from '@ant-design/icons';
import UnsplashService from 'services/UnsplashService';

const App = (props) => {
  const [selectedImage, setSelectedImage] = useState();
  const [imageList, setImageList] = useState([]);
  const [searchTerm, setSearchTerm] = useState();

  const { showImageSelectorModal, handleChange } = props;

  const customImageList = [
    'https://www.ipixtechnologies.com/images/E-LEarning-startups.png',
    'https://i0.wp.com/red-kiwi.fr/wp-content/uploads/2018/09/shutterstock_1113518771.jpg?resize=790%2C527&ssl=1',
    'https://elearningindustry.com/wp-content/uploads/2021/11/eLearning-Startup-Guide-7-Tips-You-Should-Follow.jpg',
    'https://elearningindustry.com/wp-content/uploads/2021/08/Top-5-Benefits-Of-eLearning-Education.png',
    'https://www.shutterstock.com/image-photo/diverse-people-working-startup-business-260nw-210979942.jpg',
    'https://reputationtoday.in/wp-content/uploads/2021/06/empathy-and-compassion.jpg',
    'https://www.startupindia.gov.in/nsa/assets/img/HealthBanner.jpg',
    'https://mobisoftinfotech.com/resources/wp-content/uploads/2020/09/og-healthcare-startups.png',
    'https://www.cmarix.com/blog/wp-content/uploads/2021/02/x15-Innovative-Healthcare-Startup-App-Ideas-That-Need-To-Be-Invented.png.pagespeed.ic.VrahZxw3z0.png',
  ]

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      // Send Axios request here
      const callUnplash = UnsplashService.searchImage;
      searchTerm && Promise.resolve(callUnplash(searchTerm)).then((result) => {
        const URLs = result?.map((v, i) => {
          return v.urls.small;
        });
        setImageList(URLs)
      })
    }, 1000)

    return () => clearTimeout(delayDebounceFn)
  }, [searchTerm])


  useEffect(() =>{
    const callUnplash = UnsplashService.searchImage;
    Promise.resolve(callUnplash('startup')).then((result) => {
    const URLs = result?.map((v, i) => {
      return v.urls.small;
    });
    setImageList(URLs)
  });
  }, [])
  
  const selectImage = () => {
    selectedImage && handleChange(selectedImage, searchTerm);
    showImageSelectorModal(false);
  };


  return (
    <>
      <Modal
        title='Search Images'
        centered
        visible={true}
        onOk={() => selectImage()}
        onCancel={() => showImageSelectorModal(false)}
        width={900}>
        <div >
          <Input
            placeholder='Search'
            prefix={<SearchOutlined />}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{ width: '20rem' }}
          />
        </div>
        <div className='scrollable-container'>
          <div className='background' >
              <ImagePicker
                images={ imageList?.length>0 ? imageList?.map((image, i) => ({
                  src: image,
                  value: i,
                })):customImageList.map((image, i) => ({
                  src: image,
                  value: i,
                }))}
                onPick={(e) => {
                  setSelectedImage(e.src);
                }}
              />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default App;



